import { PaginationContext } from "./chunk-6MXG22MP.js";
import { Link_default } from "./chunk-TK6RORJT.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Pagination/Pagination.Button.tsx
import { forwardRef, useContext, useCallback } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var DEFAULT_COMPONENT = "a";
var PAGINATION_BUTTON_CLASSNAME_MAP = {
  variant: {
    prev: "",
    next: ""
  }
};
var PaginationButton = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      variant,
      disabled: disabledProp,
      onClick,
      className
    } = _b,
    rest = __objRest(_b, ["as", "variant", "disabled", "onClick", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  const {
    currentPage,
    totalPages
  } = useContext(PaginationContext);
  const disabled = disabledProp || variant === "prev" && currentPage === 1 || variant === "next" && currentPage === totalPages;
  const handleClick = useCallback(event => {
    if (disabled) {
      event.preventDefault();
      return false;
    }
    if (variant === "prev") {
      onClick == null ? void 0 : onClick(Math.max(currentPage - 1, 1), event);
    }
    if (variant === "next") {
      onClick == null ? void 0 : onClick(Math.min(currentPage + 1, totalPages), event);
    }
    return true;
  }, [disabled, variant, onClick, currentPage, totalPages]);
  return /* @__PURE__ */jsx(Link_default, __spreadProps(__spreadValues({
    ref,
    as: Component,
    variant: "secondary"
  }, rest), {
    iconBefore: variant === "prev" ? "chevron-left" : void 0,
    iconAfter: variant === "next" ? "chevron-right" : void 0,
    disabled: as === "button" ? disabled : void 0,
    onClick: handleClick,
    className: clsx("pd:pagination__button", PAGINATION_BUTTON_CLASSNAME_MAP.variant[variant], disabled && "pd:pagination__button--disabled", className)
  }));
});
var StoryPaginationButton = args => /* @__PURE__ */jsx(PaginationButton, __spreadValues({}, args));
var Pagination_Button_default = PaginationButton;
export { StoryPaginationButton, Pagination_Button_default };